import Box from '@mui/material/Box';
import buildLinkObj, { getRel } from '@repo/ui/src/functions/build-link';
import MobileIconOrPhotoLinks from './_MobileIconOrPhotoLinks';
import { MobileSubnavItem } from './styles';

const MobileSubCategory = ({ subCategory, categoryLink }) => {
  if (!subCategory) return null;

  if (subCategory.links?.length) {
    return (
      <>
        <Box pt={2}>
          {subCategory?.heading && categoryLink && (
            <MobileSubnavItem
              component="a"
              key={categoryLink.href}
              href={categoryLink.href}
              rel={getRel(categoryLink)}
              sx={{ border: 'none' }}
              noBackground
            >
              {subCategory.heading?.displayName}
            </MobileSubnavItem>
          )}
          {subCategory.links.map((subCategoryLink, index) => {
            if (!subCategoryLink) return null;

            const linkObj = buildLinkObj(subCategoryLink);
            return (
              <MobileSubnavItem key={index} component="a" href={linkObj.href} rel={getRel(linkObj)}>
                {subCategoryLink.displayName}
              </MobileSubnavItem>
            );
          })}
        </Box>
        <hr aria-hidden />
      </>
    );
  }

  return (
    <MobileIconOrPhotoLinks
      links={subCategory.linksWithPhotos ? subCategory.linksWithPhotos : subCategory.linksWithIcons}
      iconOrPhoto={subCategory.linksWithPhotos ? 'Photo' : 'Icon'}
    />
  );
};

export default MobileSubCategory;
